"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Provider: function() {
        return _index.Provider;
    },
    useFluent: function() {
        return _index.useFluent;
    }
});
const _index = require("./ProviderContext/index");
